var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSearchLens(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.926,2.052c15.625-1.136,25.285,16.468,16.139,29.017l10.554,10.691c1.51,2.762-1.796,5.559-4.245,3.565l-10.379-10.306c-8.673,6.249-20.898,3.667-26.384-5.413C-2.391,18.017,5.471,3.031,18.926,2.052ZM19.459,7.616c-9.783.705-15.149,11.667-9.582,19.793,5.243,7.652,16.919,7.111,21.472-.934,4.937-8.724-1.874-19.58-11.89-18.859Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.927,12.112c2.115-.351,3.809,1.543,3.191,3.574-.459,1.507-1.941,1.959-2.096,4.138-.151,2.139.627,2.564,1.659,4.054,1.853,2.675-1.302,5.851-4.041,3.891-2.418-1.731-3.468-6.05-3.185-8.85.211-2.095,2.147-6.42,4.472-6.806Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchLens);
export default __webpack_public_path__ + "static/media/icon-search-lens.108dca3a2b858507c497256fc6a8330e.svg";
export { ForwardRef as ReactComponent };